import { IFetchPaymentPlanItem } from "@ascendnow/shared";

export interface AscPricingPlan extends IFetchPaymentPlanItem {
  percentSaved?: number;
  unitAmount: number;
  planDurationType?: "month" | "year";
  description: string;
  features: {name:string}[];
  type?: "basic" | "professional";
}

export const DEFAULT_PRICING_PLANS: AscPricingPlan[] = [
  {
    id: "basic-1",
    name: "Basic",
    unitAmount: 99.99,
    currency: "usd",
    planDurationType: "month",
    description: "The perfect way to get started and get used our tools",
    type: "basic",
    priceId: "price1",
    active: true,
    isPurchased: false,
    features: [
      {name:"Free 7-days trial for new user"},
      {name:"Free 7-days trial for new user"},
      {name:"Free 7-days trial for new user"},
    ],
    price:{
      interval:"month",
      intervalCount:0,
      overall: 20,
      monthly:10
    },
    metadata:{
      save:"10"
    }
  },
  {
    id: "professional-1",
    name: "Professional",
    percentSaved: 40,
    unitAmount: 99.99,
    currency: "usd",
    planDurationType: "month",
    description: "The perfect way to get started and get used our tools",
    features: [
      {name:"Free 7-days trial for new user"},
      {name:"Free 7-days trial for new user"},
      {name:"Free 7-days trial for new user"},
    ],
    price:{
      interval:"month",
      intervalCount:0,
      overall: 20,
      monthly:10
    },
    metadata:{
      save:"10"
    },
    type: "basic",
    priceId: "price2",
    active: true,
    isPurchased: false,
  },
  {
    id: "basic-2",
    name: "Basic",
    unitAmount: 99.99,
    currency: "usd",
    planDurationType: "month",
    description: "The perfect way to get started and get used our tools",
    features: [
      {name:"Free 7-days trial for new user"},
      {name:"Free 7-days trial for new user"},
      {name:"Free 7-days trial for new user"},
    ],
    price:{
      interval:"month",
      intervalCount:0,
      overall: 20,
      monthly:10
    },
    metadata:{
      save:"10"
    },
    type: "basic",
    priceId: "price3",
    active: true,
    isPurchased: false,
  },
];
